import { defineMessages } from 'react-intl'

const scope = `procurify.components.TaxInclusiveCheckbox`

export default defineMessages({
  inclusiveLabel: {
    id: `${scope}.inclusiveLabel`,
    defaultMessage: 'Incl.',
  },
  ariaLabel: {
    id: `${scope}.ariaLabel`,
    defaultMessage: 'Is tax inclusive',
  },
})
